import React, { FC } from 'react';

import { useAppSelector } from 'store/hooks';
import { ThemeModeSelector } from 'store/themeMode';

import useStyles from './styles';

const Loader: FC = () => {
  const themeMode = useAppSelector(ThemeModeSelector);
  const classes = useStyles({ themeMode });
  return (
    <div className={classes.loader}>
      <div className={classes.ldsRing}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
